import { ref, computed, type Ref, ShallowRef, shallowRef, ComputedRef } from "vue";
import ValidationError from "../xmlrdb-metadata/ValidationError";
import AttributeMeta from "../xmlrdb-metadata/Attribute";
import type DataElement from "./DataElement";
import Events from "../utils/Events";


interface AttributeOpts {
  dataElement: DataElement;
  metadata: AttributeMeta;
}

export type AttributeType = String | Number | Boolean | Date | null;

export default class Attribute<T extends AttributeType = AttributeType> extends Events{

  ref: ShallowRef<T | null>;
  initialValue: ShallowRef<T | null>;
  metadata: AttributeMeta
  dataElement: DataElement;
  options: AttributeOpts;
  disabled: Ref<boolean> = ref(false);

  stringValue = computed(() => this.metadata.stringifyValue(this.value));
  hasChanged = computed(() => {
    let result = this.metadata.isChangable() && this.ref.value !== this.initialValue.value;
    // if (result) {
    //   console.log(this.dataElement.namedpath(), this.metadata.name(), "haschanged");
    // }
    return result;
  });

  onChangeReenterPassword: ComputedRef<boolean> = computed(() => {
    return this.metadata.onChangeReenterPassword(this);
  })

  validatorResult: ComputedRef<ValidationError[]>;
  
  errors = computed(() => this.validatorResult.value.filter(e => e.servity === ValidationError.SeverityError));  // validatorFunction liefert die Valdator-FUNKTION zurück und validiert nicht selbst
  hasError = computed(() => !!this.errors.value.length);
  warnings = computed(() => this.validatorResult.value.filter(e => e.servity === ValidationError.SeverityWarning));  // validatorFunction liefert die Valdator-FUNKTION zurück und validiert nicht selbst
  hasWarning = computed(() => !!this.warnings.value.length);
  compareValue = computed(() => this.compareValueFunc());

  constructor(initialValue: T | null = null, options: AttributeOpts) {
    super();
    this.ref = shallowRef(initialValue) as ShallowRef<T>;
    this.initialValue = shallowRef(initialValue) as ShallowRef<T>;
    
    this.options = options;
    this.metadata = options.metadata;
    this.dataElement = options.dataElement;

    this.validatorResult = computed(() => this.metadata.validate(this));

  }

  compareValueFunc(): AttributeType {
    return this.ref.value;
  }

  reset() {
    const oldValue = this.ref.value;
    this.ref.value = this.initialValue.value;
    this.dispatch("reset", {
      oldValue: oldValue,
      newValue: this.ref.value,
      attribute: this,
    });
  }

  acceptChange() {
    this.initialValue.value = this.ref.value;
  }

  get value() {
    return this.ref.value;
  }

  set value(val) {
    this.ref.value = val;
  }
}